module.exports = __webpack_public_path__ + "static/media/farina_logo.92196f70.jpg";